import { forwardRef, type ReactNode } from "react"
import Button, { type ButtonProps } from "@mui/material/Button"
import type { SxProps, Theme } from "@mui/material/styles"

const style = {
  borderRadius: 50,
  minWidth: "7rem",
  whiteSpace: "nowrap" as const,
}

const generateColorStyle = (color?: string) => {
  return color && { color, borderColor: color }
}

export type PhenoButtonProps = Omit<ButtonProps, "color"> & {
  children: ReactNode
  color?: string
  sx?: SxProps<Theme>
}

const PhenoButton = forwardRef<HTMLButtonElement, PhenoButtonProps>(({ children, color, sx = {}, ...props }, ref) => {
  const sxList: SxProps<Theme> = [style, generateColorStyle(color) || {}, ...(Array.isArray(sx) ? sx : [sx])]
  return (
    <Button sx={sxList} variant="contained" color="primary" ref={ref} {...props}>
      {children}
    </Button>
  )
})

PhenoButton.displayName = "PhenoButton"

export default PhenoButton
